import "./index.scss"

const CardProjected = ({ children,
                         maxWidth = null,
                         bgColor = "#2e5de6",
                         borderColor = "#6EBEFF",
                         color = "#ffffff"}) => {
  return (
    <div className="card-projected" style={{maxWidth: maxWidth, backgroundColor: bgColor, color: color}} data-border={bgColor}>
      <div className="card-projected-content">
        {children}
      </div>
      <span className="border" style={{borderColor: borderColor}}></span>
    </div>
  )
}

export default CardProjected